import axis from '../../modules/axis';
function axisDefault(scale, axisToggle) {
  let axisTitle = this.axisTitles().filter(
    d => d.target === axisToggle.target && (!d.field || d.field === axisToggle.field) && (!d.shape || d.shape === axisToggle.shape)
  );
  if (axisTitle.length > 0) axisTitle = axisTitle[0];
  else axisTitle = null;

  let curAxis = axis();
  curAxis.scale(scale)
    .target(axisToggle.target)
    .field(axisToggle.field)
    .orient(axisToggle.orient)
    .tickFormat(axisToggle.tickFormat)
    .title(axisTitle ? axisTitle.title : axisToggle.title)
    .titleOrient(axisToggle.titleOrient)
    .transition(this.transition());
  if (scale._scaleType && scale._scaleType === 'time' && scale._field) { //scaleTime이고 interval 있는 경우 
    let field = scale._field;
    if (!field.autoFormat) {
      if (field.interval) curAxis.interval(field.interval);
      if (field.format) curAxis.tickFormat(field.format);
    }
  }
  else curAxis.interval(null);
  if(axisToggle.tickPadding !== undefined) curAxis.tickPadding(axisToggle.tickPadding);
  if(axisToggle.thickness !== undefined) curAxis.thickness(axisToggle.thickness);
  if(axisToggle.showTitle !== undefined) curAxis.showTitle(axisToggle.showTitle);
  if(axisToggle.showDomain !== undefined) curAxis.showDomain(axisToggle.showDomain);
  if(axisToggle.showTicks !== undefined) curAxis.showTicks(axisToggle.showTicks);
  this.axisExec(axisToggle.target, axisToggle.field, curAxis);
  return curAxis;
}

export default axisDefault;


// WEBPACK FOOTER //
// ./layouts/rectLinear/axisDefault.js